
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/search",
      function () {
        return require("private-next-pages/shop/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/search"])
      });
    }
  